import { render, staticRenderFns } from "./IconDraggable.vue?vue&type=template&id=499e9036&"
import script from "./IconDraggable.vue?vue&type=script&lang=js&"
export * from "./IconDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports